import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { InfoWrapper, InfoGroup, Signals, SignalsCount, Button } from './info-block.styled';

export const InfoBlock = ({ openWindow }) => {
  const { t } = useTranslation();
  const signals = useSelector((store) => store.events.events, shallowEqual);

  /**
   * get signals
   * @returns
   */
  const getSignals = () => {
    //let signals = 0;
    let warnings = 0;
    let errors = 0;

    for (let rack in signals) {
      for (let key in signals[rack]) {
        switch (signals[rack][key].type) {
          case 'critical':
            errors += 1;
            break;
          case 'notification':
            if (signals[rack][key].message !== 'Dispenser status' && signals[rack][key].message !== 'Stacker status') {
              warnings += 1;
            }
            break;
          case 'signal':
          default:
            //signals += 1;
            break;
        }
      }
    }

    return (
      <>
        {/*<SignalsCount priority={3}>{signals}</SignalsCount>*/}
        <SignalsCount priority={2}>{warnings}</SignalsCount>
        <SignalsCount priority={1}>{errors}</SignalsCount>
      </>
    );
  };

  /*
  function getMissCallCount() {
    const count = 0;
    if (count) {
      return (
        <CallsCount>
          <img src="./images/miss_call_icon.png" alt="" />
          <span>{count}</span>
        </CallsCount>
      );
    } else {
      return null;
    }
  }
  */

  const signalsEl = getSignals();

  return (
    <InfoWrapper>
      <InfoGroup onClick={() => openWindow({ id: 'events', type: 'signals' })}>
        <p>{t('widgets.Сигналы')}</p>
        <Signals>{signalsEl}</Signals>
      </InfoGroup>
      {window.config.objects?.payments?.length > 1 && (
        <Button title={t('widgets.Сводная таблица по АПП')} onClick={() => openWindow({ id: 'denominations2', type: 'denominations2' })}>
          {t('common.valute')}
        </Button>
      )}

      {/*
        <Separator />
        <InfoGroup onClick={() => dispatch(openWindow({
          id: 'audio',
          type: 'calls'
      }))}>
          <p>Аудиосвязь</p>
          {getMissCallCount()}
        </InfoGroup>
        */}
    </InfoWrapper>
  );
};
